import { render, staticRenderFns } from "./QuestionsSegment2.vue?vue&type=template&id=1a2a0b0e&scoped=true&"
import script from "./QuestionsSegment2.vue?vue&type=script&lang=js&"
export * from "./QuestionsSegment2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSegment2.vue?vue&type=style&index=0&id=1a2a0b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a0b0e",
  null
  
)

export default component.exports